var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSat1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1237_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1659 35.7294V33.8359H36.4371C36.4371 36.286 34.451 38.2722 32.0009 38.2722C29.5508 38.2722 27.5646 36.286 27.5646 33.8359H18.8359V35.7294L22.6262 36.1308C22.8627 37.0999 23.2455 38.0117 23.7499 38.8414L21.3529 41.8061L24.0307 44.4839L26.9954 42.0869C27.8251 42.5914 28.7369 42.9742 29.7061 43.2106L30.1074 47.0009H33.8944L34.2957 43.2106C35.2649 42.9742 36.1767 42.5914 37.0064 42.0869L39.9711 44.4839L42.6488 41.8061L40.2519 38.8414C40.7563 38.0117 41.1391 37.0999 41.3755 36.1308L45.1659 35.7294Z",
    fill: "#B41B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0019 17C30.127 17 28.6016 18.5254 28.6016 20.4004C28.6016 22.2753 30.127 23.8007 32.0019 23.8007C33.8769 23.8007 35.4023 22.2753 35.4023 20.4004C35.4023 18.5254 33.8769 17 32.0019 17Z",
    fill: "#B41B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6231 24.7422H28.3825C26.7155 24.7422 25.3594 26.0983 25.3594 27.7653V32.0786H38.6462V27.7653C38.6462 26.0983 37.2901 24.7422 35.6231 24.7422Z",
    fill: "#B41B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7883 18.5703C23.1087 18.5703 21.7422 19.9368 21.7422 21.6164C21.7422 23.2825 23.087 24.6397 24.748 24.6615C25.4359 23.8569 26.3851 23.2826 27.4635 23.072C27.6998 22.6392 27.8344 22.1433 27.8344 21.6164C27.8344 19.9368 26.4679 18.5703 24.7883 18.5703Z",
    fill: "#B41B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5441 25.5078C20.0508 25.5078 18.8359 26.7226 18.8359 28.216V32.0799H23.5997V27.7665C23.5997 26.95 23.8058 26.1809 24.1682 25.5078H21.5441Z",
    fill: "#B41B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2141 18.5703C37.5344 18.5703 36.168 19.9368 36.168 21.6164C36.168 22.1432 36.3025 22.6392 36.5389 23.072C37.6173 23.2826 38.5664 23.8569 39.2543 24.6615C40.9154 24.6398 42.2602 23.2825 42.2602 21.6164C42.2602 19.9368 40.8937 18.5703 39.2141 18.5703Z",
    fill: "#B41B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4562 25.5078H39.832C40.1944 26.1809 40.4006 26.95 40.4006 27.7665V32.0799H45.1643V28.2159C45.1643 26.7226 43.9494 25.5078 42.4562 25.5078Z",
    fill: "#B41B05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1237_183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSat1);
export default __webpack_public_path__ + "static/media/sat-1.f99ab204fc6838a0c512f1d328083723.svg";
export { ForwardRef as ReactComponent };